<template>
    <div>
        <p class='simple-error pulse' v-show='errorMessage'>
            {{errorMessage}}
        </p>
        <div v-if="gasPriceMedium">
        	<div id='gas_price' v-if="config.blockchainId === 'ethereum'"><span>Gas Priority Fee:</span><br />
                <input id="gasstandard" type="radio" name="gas" :value='gasPriceMedium' @click='customGasDisabled = true; gasPrice = gasPriceMedium'>
                <label for="gasstandard">{{Math.round(gasPriceMedium)}} Standard</label>

                <input id="gasfast" type="radio" name="gas" checked :value='gasPriceFast' @click='customGasDisabled = true; gasPrice = gasPriceFast'>
                <label for="gasfast">{{Math.round(gasPriceFast)}} Fast</label>

                <input id="gasinstant" type="radio" name="gas" :value='gasPriceFastest' @click='customGasDisabled = true; gasPrice = gasPriceFastest'>
                <label for="gasinstant">{{Math.round(gasPriceFastest)}} Instant</label>
                <input id="custom_gas" type="radio" name="gas" value='-' @click="customGasDisabled = false; gasPrice = gasPriceSlow">
                <label for="custom_gas" @click="customGasDisabled = false; gasPrice = gasPriceSlow">
                    <input type="text" id="custom_gas_input"
                        :disabled='customGasDisabled'
                        name="custom_gas_input"
                        :value = 'customGasPriceInput'
                       	@input='setCustomGas($event)'>
                    <span v-show='customGasPriceInput == gasPriceSlow'> Slow</span>
                    <span v-show='customGasPriceInput && customGasPriceInput < gasPriceSlow' class='gastoolow'>
                        <span class='tooltip'>
                            Low
                            <span class='tooltiptext'>
                                Too low gas price. Your transaction may be dropped.
                            </span>
                        </span>
                    </span>
                </label>
            </div>
            <div v-else id='gas_price'>
                <span>Gas price:</span>
                <input id="gasfast" type="radio" name="gas" checked :value='gasPriceFast' @click='customGasDisabled = true; gasPrice = gasPriceFast'>
                <label for="gasfast">{{Math.round(gasPriceFast)}} Fast</label>
            </div>
        </div>
    </div>
</template>

<script>
    import config from '@/constants/config'
    import { truncWithoutZeroDecimals } from '@/utils/Number'
    import { getGasPrice } from '@/utils/GasPrice'
	  import { state } from './gasPriceStore'
    import { state as errorState } from './errorStore'
    import { retry } from '../../utils/helpers'
    import { contract } from '@/contract';

    import { setIntervalAsync, clearIntervalAsync } from 'set-interval-async/dynamic'

    import BN from 'bignumber.js'

    const safeZero = (number) => number < 0.1 ? 0 : number;

	export default {
		data: () => ({
            config,
            customGasDisabled: true,
		}),

		computed: {
            gasPriceSlow() {
                switch (config.blockchainId) {
                    case 'polygon':
                        return 30;
                    case 'ethereum':
                        return state.gasPriceInfo.prio && truncWithoutZeroDecimals(safeZero(state.gasPriceInfo.prio.low), 1) || 15;
                    default:
                        return state.gasPriceInfo && state.gasPriceInfo.low || 15;
                }
            },
			gasPriceMedium() {
                switch (config.blockchainId) {
                    case 'polygon':
                        return 30;
                    case 'ethereum':
                        return state.gasPriceInfo.prio && truncWithoutZeroDecimals(safeZero(state.gasPriceInfo.prio.standard), 1) || 20;
                    default:
                        return state.gasPriceInfo && state.gasPriceInfo.standard || 20;
                }
            },
            gasPriceFast() {
                switch (config.blockchainId) {
                    case 'polygon':
                        return 30;
                    case 'ethereum':
                        return state.gasPriceInfo.prio && truncWithoutZeroDecimals(safeZero(state.gasPriceInfo.prio.fast), 1) || 25;
                    default:
                        return state.gasPriceInfo && state.gasPriceInfo.fast || 25;
                }
            },
            gasPriceFastest() {
                switch (config.blockchainId) {
                    case 'polygon':
                        return 30;
                    case 'ethereum':
                        return state.gasPriceInfo.prio && truncWithoutZeroDecimals(safeZero(state.gasPriceInfo.prio.instant), 1) || 30;
                    default:
                        return state.gasPriceInfo && state.gasPriceInfo.instant || 30;
                }
            },

            /**
             * On Ethereum, the gasPrice variable represents the priority fee.
             * On other chains, it represents the gasPrice parameter itself, as for pre-eip1559 Ethereum.
             */
            gasPrice: {
            	get() {
                    if (config.blockchainId === 'polygon') return 30;

            		return state.gasPrice
            	},
            	set(val) {
            		state.gasPrice = val
            	},
            },
            customGasPriceInput() {
            	if(this.customGasDisabled) return this.gasPriceSlow
            	return this.gasPrice
            },
            errorMessage() {
                setTimeout(() => errorState.txError = null, 5000)
                return errorState.txError
            },
		},

		async created() {
            if (config.blockchainId === 'ethereum') {
                if (!state.fetched) this.getGasPrice();
                if (state.gasPriceInterval) clearIntervalAsync(state.gasPriceInterval);
                if(!state.gasPriceInterval || state.gasPriceInterval.stopped) {
                    state.gasPriceInterval = setIntervalAsync(() => this.getGasPrice(), 3000)
                }
    			this.$watch(() => state.gasPrice, val => {
    				state.gasPriceWei = BN(val).times(1e9).toFixed(0,1)
    			}, {
    				immediate: true,
    			})
            } else {
                const gasPrice = (await contract.web3.eth.getGasPrice()) / 1e9;
                state.gasPrice = gasPrice
                state.gasPriceWei = BN(gasPrice).times(1e9).toFixed(0,1)
                state.gasPriceInfo = {
                    low: gasPrice - 2,
                    standard: gasPrice,
                    fast: gasPrice + 2,
                    instant: gasPrice + 4,
                };
            }
		},

        methods: {
            async getGasPrice() {
                const { data: { eip1559Gas: gasInfo} } = await getGasPrice();
                const DECIMALS_GWEI = 1e9;

                const [prioInstant, prioFast, prioStandard, prioLow] = gasInfo.prio;
                const [maxInstant, maxFast, maxStandard, maxLow] = gasInfo.max;

                state.gasPriceInfo = {
                    base: gasInfo.base / DECIMALS_GWEI,
                    prio: {
                        instant: prioInstant / DECIMALS_GWEI,
                        fast: prioFast / DECIMALS_GWEI,
                        standard: prioStandard / DECIMALS_GWEI,
                        low: prioLow / DECIMALS_GWEI,
                    },
                    max: {
                        instant: maxInstant / DECIMALS_GWEI,
                        fast: maxFast / DECIMALS_GWEI,
                        standard: maxStandard / DECIMALS_GWEI,
                        low: maxLow / DECIMALS_GWEI,
                    },
                };

                if(state.gasPriceInfo.prio.fast > 2000) throw new Error('too high!')

                if(!state.fetched) {
                    state.gasPrice = config.blockchainId === 'ethereum' ?
                        state.gasPriceInfo.prio.fast : state.gasPriceInfo.fast
                    state.fetched = true
                }
            },

            async setCustomGas(event) {
                let value = event.target.value
                if(event.target.value > this.gasPriceFastest * 2)
                    value = this.gasPriceFastest * 2
                this.gasPrice = value
            },
        },

	}
</script>

<style scoped>
    .pulse {
        animation: pulse 1s 3;
        margin-bottom: 8px;
    }
    #custom_gas_wrapper {
        margin-top: 0.4em;
        margin-left: 6em;
        display: block;
    }
    .gastoolow {
        color: darkred;
    }
    @media only screen and (max-device-width: 730px) {
        #custom_gas_wrapper, #gas_price label {
            margin-top: 0;
            margin-left: 0;
        }
    }
</style>
